import React from 'react';
import { ErrorBoundary } from '../../utils';
import { TabType } from '../../models';

export const WithHotelErrorBoundary = (Component) => {
    const HOC = (props) => (
        <ErrorBoundary key={TabType.HOTELS}>
            <Component {...props} />
        </ErrorBoundary>
    );
    HOC.displayName = Component.displayName || Component.name || 'HotelErrorBoundary';
    return HOC;
};
